import React, { useEffect, useMemo, useState } from 'react'
import Loading from '../feedback/Loading'
import toast from 'react-hot-toast'
import utils from '../../utils'
import { HiTrash } from 'react-icons/hi'
import productServices from '../../services/ProductsServices'
import { useSession } from '../../context/SessionContext'
import moment from 'moment'

function ProductBrandModal(props) {
    const [name, setName] = useState("")
    const [loading, setLoading] = useState(false)
    const action = props.action
    const activeBrand = props.activeBrand
    const { setBrands } = useSession()
    const [activeTab, setActiveTab] = useState(0)

    // Tabs: Info + Delete (only if editing)
    const tabs = useMemo(() => {
        const baseTabs = ['Info'];
        if (action === 1) {
            return [...baseTabs, 'Delete'];
        }
        return baseTabs;
    }, [action]);

    useEffect(() => {
        if (action === 1 && activeBrand) {
            setName(activeBrand?.name)
        }
    }, [action, activeBrand])

    async function updateSession() {
        productServices.getBrands().then(
            res => {
                setBrands(res.data)
            },
            err => {
                console.log("Session update error");
                console.log(err);
            }
        )
    }

    function submitHandler(e) {
        const closeBtn = document.getElementById("product-brand-modal-close-btn")
        e.preventDefault()
        setLoading(true)
        const data = {
            "name": name
        }
        productServices.addBrand(data).then(
            res => {
                toast.success("Product Brand Added Successfully")
                setLoading(false)
                props.getBrands()
                updateSession()
                closeBtn.click()
            },
            err => {
                toast.error(utils.toastError)
                console.log(err);
                setLoading(false)
            }
        )
    }

    function clearInput() {
        setName("")
        setActiveTab(0) // reset tab when closing
    }

    function deleteHandler(id) {
        const closeBtn = document.getElementById("product-brand-modal-close-btn")
        setLoading(true)
        productServices.deleteBrand(id).then(
            res => {
                toast.success("Brand Deleted Successfully")
                setLoading(false)
                props.getBrands()
                updateSession()
                closeBtn.click()
            },
            err => {
                toast.error(utils.toastError)
                console.log(err);
                setLoading(false)
            }
        )
    }

    const changeTab = (idx) => {
        if (action === 1) {
            setActiveTab(idx);
        }
    };

    return (
        <div>
            <label htmlFor="product-brand-modal" id='product-brand-open-btn' className="hidden">Add / Update Brand</label>
            <input type="checkbox" id="product-brand-modal" className="modal-toggle" />
            <div className="modal">
                <div className="modal-box w-8/11 max-w-2xl">
                    <label
                        onClick={() => clearInput()}
                        htmlFor="product-brand-modal"
                        id='product-brand-modal-close-btn'
                        className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">✕</label>

                    <h2 className='text-lg font-bold mb-2'>
                        {action === 1 ? 'View' : 'Add'} Brand
                        {action === 1 && activeBrand && (
                            <span className='ml-2 text-gray-500'>{activeBrand?.name}</span>
                        )}
                    </h2>

                    {/* Tabs */}
                    <div className="flex justify-center mb-6">
                        <div className="border-gray-200 dark:border-border-dark">
                            <div className="tabs tabs-boxed justify-center">
                                {tabs.map((tab, idx) => (
                                    // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                    <a
                                        key={idx}
                                        className={`tab ${activeTab === idx
                                            ? 'tab-active bg-primary text-white rounded-lg'
                                            : ''
                                            }`}
                                        onClick={() => changeTab(idx)}
                                        role="tab"
                                        aria-selected={activeTab === idx}
                                    >
                                        {tab}
                                    </a>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Info Tab */}
                    {activeTab === 0 && (
                        <>
                            {action === 1 && activeBrand && (
                                <div className='mb-4 grid grid-cols-1 gap-3 md:grid-cols-2'>
                                    <div className="flex justify-center">
                                        {/* Placeholder avatar since no image */}
                                        <div className="avatar placeholder">
                                            <div className="bg-neutral text-neutral-content text-lg rounded-md h-36 w-36">
                                                {String(activeBrand?.name).charAt(0).toLocaleUpperCase()}
                                            </div>
                                        </div>
                                    </div>
                                    <div className='border p-3 rounded-lg shadow-md'>
                                        <p className="font-bold mb-1">Overview</p>
                                        <div>
                                            <p><span className='font-bold mr-2'>Model Count:</span> {activeBrand?.model_count}</p>
                                            <p><span className='font-bold mr-2'>Product Count:</span> {activeBrand?.product_count}</p>
                                            <p>Created On: <span className='font-bold ml-3 text-gray-600'>{moment(activeBrand?.creation_time).format("MMM Do YYYY")}</span></p>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <form onSubmit={submitHandler}>
                                <div className="form-control mb-3">
                                    <label className="label">
                                        <span className="label-text">Name:</span>
                                    </label>
                                    <input
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        type="text"
                                        required
                                        className="input input-bordered w-full"
                                    />
                                </div>

                                {action === 0 && (
                                    <div className='mt-6'>
                                        <button
                                            className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-red-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-75"
                                            type="submit"
                                            disabled={loading}
                                        >
                                            {loading ? 'Adding...' : 'Add'}
                                        </button>
                                    </div>
                                )}
                            </form>
                        </>
                    )}

                    {/* Delete Tab */}
                    {activeTab === 1 && action === 1 && (
                        <div className="border-base-200">
                            <div className="bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-border-light dark:border-border-dark overflow-hidden">
                                <div className="p-6 md:p-8">
                                    <div className="border-l-4 border-error pl-4 py-2">
                                        <h3 className="font-bold text-error">Warning</h3>
                                        <p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
                                            Deleting this brand is irreversible and will also delete all related models and products.
                                        </p>
                                        <div className="pt-4">
                                            {loading ? (
                                                <Loading />
                                            ) : (
                                                <button
                                                    type="button"
                                                    onClick={() => deleteHandler(activeBrand?.id)}
                                                    className="flex items-center space-x-2 bg-error text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-error/90 transition-colors"
                                                >
                                                    <HiTrash className="h-4 w-4" />
                                                    <span>Delete Brand</span>
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default ProductBrandModal